/**
 * @typedef {Object} InitialStateResponse
 * @property {number} balance
 * @property {number} rate
 * @property {number} precision
 * @property {number} maxWinLimit
 * @property {string} currencyCode
 * @property {Array<number>} quickBets
 * @property {Object} additionalInfo
 * @property {Object} gameConfiguration
 * @property {Object} bonusSpinInfo
 * @property {number} bonusSpinInfo.id
 * @property {number} bonusSpinInfo.multiplier
 * @property {number} bonusSpinInfo.remainingSpinCount
 * @property {number} bonusSpinInfo.winAmount
 * @property {Array<number>} bonusSpinInfo.results
 * @property {Object} bonusSpinInfo.bonusData
 * @property {Array<{ball, count}>} bonusSpinInfo.bonusData.bonusInfo
 * @property {Object} spinInfo
 * @property {number} spinInfo.id
 * @property {number} spinInfo.id
 * @property {number} spinInfo.amount
 * @property {number} spinInfo.winAmount
 */

export class AbstractGameService {
  async spin(...args) {
    throw new Error(`unimplemented spin in ${this.constructor.name}`);
  }

  async bonusSpin(...args) {
    throw new Error(`unimplemented bonusSpin in ${this.constructor.name}`);
  }

  async preBonusSpin(...args) {
    throw new Error(`unimplemented preBonusSpin in ${this.constructor.name}`);
  }

  async buyBonus(...args) {
    throw new Error(`unimplemented buyBonus in ${this.constructor.name}`);
  }

  /**
   * @name getInitialState
   * @param {Object} params
   * @param {number} params.partnerId
   * @param {boolean} params.IsDemo
   * @param {Object} config
   * @param {string} config.v - APi version
   * @return {Promise<InitialStateResponse>}
   */
  async getInitialState(params, config) {
    throw new Error(`unimplemented getInitialState in ${this.constructor.name}`);
  }
}
